import { useContext } from "react";

import { trans } from "@/service/i18n/i18n";
import { UserContext } from "@/contexts/user-context";
import { Button } from "@/components/ui/button";
import { PermissionComponentProps } from "@/components/common/permission/types";

const CLUB_HOMEPAGE = "/klubmedyka";

/**
 * Treść dostępna tylko dla subskrybentów Klubu Medyka. Backend przekazuje w `data.service`,
 * czego brakuje, a dla `product` dokłada `items` (tytuł + slug usługi) — dzięki temu nie trzymamy
 * tu mapy usług i nowa usługa w Klubie nie wymaga zmiany na froncie.
 *
 * Klub to osobna aplikacja pod /klubmedyka, więc linkujemy zwykłym <a>, a nie routerem.
 */
export const ClubSubscription = ({ access }: PermissionComponentProps) => {
  const user = useContext(UserContext);

  const service = access?.data?.service as string | undefined;
  const items = (access?.data?.items ?? []) as {
    slug: string;
    title: string;
  }[];

  const { description, href } = resolveCopy(service, items);

  return (
    <>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        {description}
      </p>

      <Button asChild={true} className={"mb-4 w-full"}>
        <a href={href}>{trans("permission.club_subscription.cta")}</a>
      </Button>
    </>
  );
};

function resolveCopy(
  service: string | undefined,
  items: { slug: string; title: string }[],
) {
  if ("product" === service && items.length > 0) {
    const titles = items.map((item) => item.title).join(" lub ");

    return {
      description: `${trans(
        "permission.club_subscription.desc_prefix",
      )} ${titles} ${trans("permission.club_subscription.desc_suffix")}`,
      href:
        1 === items.length
          ? `${CLUB_HOMEPAGE}/subskrypcja/${items[0].slug}`
          : CLUB_HOMEPAGE,
    };
  }

  if ("medicover_sport" === service) {
    return {
      description: trans("permission.club_subscription.medicover_sport.desc"),
      href: `${CLUB_HOMEPAGE}/subskrypcja/medicover-sport`,
    };
  }

  if ("oc" === service) {
    return {
      description: trans("permission.club_subscription.oc.desc"),
      href: `${CLUB_HOMEPAGE}/uslugi/ubezpieczenie/oc`,
    };
  }

  if ("former" === service) {
    return {
      description: trans("permission.club_subscription.former.desc"),
      href: CLUB_HOMEPAGE,
    };
  }

  return {
    description: trans("permission.club_subscription.any.desc"),
    href: CLUB_HOMEPAGE,
  };
}
